import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import qs from 'query-string';
import * as R from 'ramda';

// TODO: remove, services should not import from components
import { SORT_ASC, SORT_DESC } from 'common/mdc/table';

const TOTAL_HEADER = 'X-Total-Count';
const CONTENT_DISPOSITION = 'Content-disposition';

export const GET = 'GET';
export const PUT = 'PUT';
export const POST = 'POST';
export const DELETE = 'DELETE';

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

const SORT_DIRECTION = {
  [SORT_ASC]: 'asc',
  [SORT_DESC]: 'desc',
};

const isDefined = R.complement(R.isNil);

export default class ApiService {
  constructor(configService) {
    this.baseURL = configService.getConfig('api', 'basename');
    this.options = {
      credentials: configService.getConfig('credentials') ? 'include' : 'omit',
      responseType: 'json',
      method: GET,
    };
  }

  static checkErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }

    return response;
  }

  static resourceJson(result) {
    return result.response;
  }

  static collectionJson(result) {
    return ({
      data: ApiService.resourceJson(result),
      total: Number(result.xhr.getResponseHeader(TOTAL_HEADER)),
    });
  }

  static downloadData(result) {
      const filename = String(result.xhr.getResponseHeader(CONTENT_DISPOSITION)).split('filename=')[1];
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(ApiService.resourceJson(result));
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return ({
          data: ApiService.resourceJson(result),
          total: Number(result.xhr.getResponseHeader(TOTAL_HEADER)),
      });
  }

  fetch(url = '', query = {}, options = {}) {
    const q = qs.stringify(query);
    const url$ = `${this.baseURL}${url}${q ? `?${q}` : ''}`;
    const { headers = {} } = options;

    return ajax(R.filter(isDefined, {
      ...this.options,
      ...options,
      url: url$,
      headers: R.filter(isDefined, {
        ...DEFAULT_HEADERS,
        ...headers,
      }),
    }));
  }

  fetchResource(url = '', options) {
    return this
      .fetch(url, null, options)
      .pipe(
        map(ApiService.resourceJson),
      );
  }

  fetchCollection(
    url = '',
    {
      limit = DEFAULT_LIMIT,
      offset = DEFAULT_OFFSET,
      sort,
      query,
      search,
      ...filters
    } = {},
    options = {},
  ) {
    return this
      .fetch(url, {
        ...filters,
        limit,
        offset,
        q: query,
        dsl: search,
        sort: sort && `${sort.property}-${SORT_DIRECTION[sort.direction]}`,
      }, options)
      .pipe(
        map(ApiService.collectionJson),
      );
  }

  downloadCollection(
    url = '',
    {
      sort,
      query,
      search,
      ...filters
    } = {},
    options = {},
  ) {
    return this
      .fetch(url, {
        ...filters,
        q: query,
        dsl: search,
        sort: sort && `${sort.property}-${SORT_DIRECTION[sort.direction]}`,
      },
      {
        responseType: 'blob',
        ...options,
      })
      .pipe(
        map(ApiService.downloadData),
      );
  }

  put(url, body = {}, options = {}) {
    return this.fetch(
      url,
      null,
      {
        body: JSON.stringify(body),
        method: PUT,
        ...options,
      },
    );
  }

  post(url, body = {}, options = {}) {
    return this.fetch(
      url,
      null,
      {
        body: JSON.stringify(body),
        method: POST,
        ...options,
      },
    );
  }

  delete(url, body = {}, options = {}) {
    return this.put(
      url,
      null,
      { body: JSON.stringify(body), method: DELETE, ...options },
    );
  }
}
